/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5e583362d2cc533532019bb475da1e8125b25989";
